import React from 'react';
import PropTypes from 'prop-types';

// pre-process message text by source
const processedText = (text) => {
  const sourceTester = new RegExp('\r\r\n')
  return sourceTester.test(text) ? text.split('\r\r\n') : text.split('\n')
}

const TextMessage = ({ text }) =>
  processedText(text)
  .map((str, index) => <p key={`weather-alert-text-${String(index)}`}>{str}</p>);

TextMessage.propTypes = {
  text: PropTypes.string.isRequired,
};

export default TextMessage;
